import { render, staticRenderFns } from "./CallHistoryInformation.vue?vue&type=template&id=5cb66880&scoped=true&"
import script from "./CallHistoryInformation.vue?vue&type=script&lang=js&"
export * from "./CallHistoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./CallHistoryInformation.vue?vue&type=style&index=0&id=5cb66880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb66880",
  null
  
)

export default component.exports